/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Button, ButtonSmall, Typography } from '@pinwheel/origami';
import useGetActionOnClick from './utils';
function Action(props) {
    var action = props.action;
    var dataTestId = "action-".concat(action.actionType);
    var onClick = useGetActionOnClick(action, props.onSubmit);
    var _a = useState(true), isPayloadButtonDisabled = _a[0], setIsPayloadButtonDisabled = _a[1];
    useEffect(function () {
        var timeoutId = null;
        if (action.actionType === 'payload') {
            if (action.enabled && action.enabledDelay) {
                timeoutId = setTimeout(function () {
                    setIsPayloadButtonDisabled(false);
                }, action.enabledDelay * 1000);
            }
            else if (!action.enabledDelay) {
                setIsPayloadButtonDisabled(!action.enabled);
            }
        }
        return function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [action]);
    return action.actionType === 'payload' ? (React.createElement(ButtonSmall, { key: action.label, variant: "ghost", color: "neutral", "data-testid": dataTestId, type: "button", onClick: onClick, disabled: isPayloadButtonDisabled },
        React.createElement(Typography, { variant: "postscript", weight: "bold", color: "light" }, action.label))) : action.actionType === 'hyperlink' ? (React.createElement(ButtonSmall, { key: action.label, "data-testid": dataTestId, variant: "ghost", color: "neutral", type: "button", href: action.href },
        React.createElement(Typography, { align: "center", variant: "postscript", weight: "bold", color: "light" }, action.label))) : action.actionType === 'search' ? (React.createElement(Button, { key: action.label, variant: "ghost", color: "neutral", "data-testid": dataTestId, type: "button", onClick: onClick },
        React.createElement(Typography, { variant: "label", color: {
                type: 'theme',
                colorLegacy: 'Blue/50',
                colorNext: 'brand/default',
            } }, action.label))) : action.actionType === 'adp_iframe' ? (React.createElement(ButtonSmall, { key: action.label, variant: "ghost", color: "neutral", "data-testid": dataTestId, type: "button", onClick: onClick },
        React.createElement(Typography, { variant: "postscript", weight: "bold", color: "light" }, action.label))) : (React.createElement(ButtonSmall, { key: action.label, variant: "ghost", color: "neutral", "data-testid": dataTestId, type: "button", onClick: onClick },
        React.createElement(Typography, { variant: "postscript", weight: "bold", color: "light" }, action.label)));
}
export default Action;
